export const footer = {
  "description": "La piattaforma di scambio di case tra proprietari Airbnb. Viaggia gratuitamente in tutto il mondo.",
  "company": "Azienda",
  "about": "Chi siamo",
  "howItWorks": "Come funziona",
  "blog": "Blog",
  "careers": "Lavora con noi",
  "support": "Supporto",
  "help": "Centro assistenza",
  "contact": "Contatti",
  "terms": "Termini di utilizzo",
  "privacy": "Informativa sulla privacy",
  "community": "Comunità",
  "members": "Membri",
  "destinations": "Destinazioni",
  "events": "Eventi",
  "newsletter": "Notiziario",
  "newsletterText": "Ricevi le nostre ultime offerte e novità",
  "emailPlaceholder": "La tua email",
  "newsletterSuccess": "Iscrizione riuscita!",
  "newsletterError": "Si è verificato un errore.",
  "newsletterInvalid": "Email non valida.",
  "subscribe": "Iscriviti",
  "rights": "Tutti i diritti riservati",
  "madeWith": "Fatto con",
  "by": "dal team DONKEY TRAVEL"
};
